import { Component } from '@angular/core'

@Component({
  templateUrl: './go-to-control.component.html',
  styleUrls: ['./go-to-control.component.scss']
})
export class GoToControlComponent {}
